const DescriptionInformation = () => {
  return (
    <>
      <ul className="pe-3 ps-0 pt-2 color-secondary">
        <li>
          <small className="color-gray-1">
            شرح حال کسب‌ و کارتان را در خصوص تاریخچه، تنوع و محصولاتتان بین 100
            تا 150 کلمه یادداشت کنید.{' '}
          </small>
        </li>
        <li>
          <small className="color-gray-1">
            حتما به سال شروع فعالیتتان در متن ارسالی اشاره کنید.
          </small>{' '}
        </li>
        <li>
          <small className="color-gray-1">
            متن ارسالی باید فاقد آدرس سایت و صفحات مجازی و هرگونه شماره تماس
            باشد.
          </small>
        </li>
      </ul>
    </>
  );
};

export default DescriptionInformation;
